import React from 'react';
import LoginForm from '../components/LoginForm';
import DeveloperCredit from '../components/common/DeveloperCredit';

const Login = () => {
  // Same frame AppLayout uses for the signed-in app: fixed-height column, scrolling
  // content, credit pinned underneath. The login screen sits outside AppLayout, so it
  // has to carry the footer itself or the credit only shows up after signing in.
  return (
    <div className="login-page flex h-screen flex-col">
      <div className="flex-1 overflow-y-auto">
        <LoginForm />
      </div>
      <DeveloperCredit variant="footer" />
    </div>
  );
};

export default Login;
